/* eslint-disable no-unused-vars */
/* eslint-disable import/order */
/* eslint-disable react/prop-types */
import { InputAdornment, MenuItem } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'

import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import BaseFilter from '../../../../components/hooks/BaseFilter'
import {  useQueryParams } from '../../../../util/utils'
import { Link, useHistory, useLocation } from 'react-router-dom'
import Icon from '@mdi/react'
import { mdiMagnify, mdiMagnifyExpand, mdiNoteEditOutline } from '@mdi/js'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'

export const Filter = ({ classes }) => {
  const permissions = useSelector(state => state.auth.permissions)

  const styles = filterStylesComponents()

  const history = useHistory()
  const location = useLocation()
  const filters = useQueryParams(location?.search)

  const [open, setOpen] = useState(false)

  const toggleModal = () => {
    setOpen(!open)
  }

  const onSubmit = (data = filters) => {
    const searchParams = new URLSearchParams(data)
    searchParams.set('page', 1)
    if (open) toggleModal()
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const handleSubmit = e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)
    const entries = data.entries()
    const values = Object.fromEntries(entries)

    onSubmit({ ...filters, ...values })
  }

  return (
    <BaseFilter>
      <Grid item xs={12}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item xs={8}>
            <form style={{ width: '100%' }} onSubmit={handleSubmit}>
              <Grid container spacing={2} alignItems="center">
                <Grid item sm={4} xs={12}>
                  <TextField
                    fullWidth
                    label="Filtrar por cliente"
                    defaultValue={filters?.client_name || ''}
                    name="client_name"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton type="submit">
                            <Icon path={mdiMagnifyExpand} size={1} />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item sm xs>
                  <IconButton className={styles.btnAdd} type="submit">
                    <Icon path={mdiMagnify} size={1} />
                    Pesquisar
                  </IconButton>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Grid>
    </BaseFilter>
  )
}
